import { render, staticRenderFns } from "./ScrollIndicator.vue?vue&type=template&id=be10ef6c"
import script from "./ScrollIndicator.vue?vue&type=script&lang=js"
export * from "./ScrollIndicator.vue?vue&type=script&lang=js"
import style0 from "./ScrollIndicator.vue?vue&type=style&index=0&id=be10ef6c&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports